import theme from '../../../../../themes/green';

const style = {
  head: Object.assign(
    { ...theme.font },
    {
      fontFamily: 'Roboto',
      fontSize: '11px',
      fontWeight: '500',
      color: '#476166',
      backgroundColor: 'white',
      textTransform: 'uppercase',
      width: '100%',
      height: '40px',
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: '15px',
      paddingRight: '25px',
    },
  ),
  headerCell: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px',
    flexBasis: '15%',
    outline: 'none',
    cursor: 'pointer',
  },
  sortIcon: {
    verticalAlign: 'initial',
    fontWeight: 'bold',
    marginLeft: '5px',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListTableHeader/ProjectListTableHeader.style.js